module.exports = __webpack_public_path__ + "img/lscl2.50d64d83.jpg";